import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet
} from '@angular/router';

import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import 'zone.js';
import { CommonModule } from '@angular/common';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

import { environment } from '../environments/environment';

@Component({
  selector: 'rental-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    TranslateModule,
    HttpClientModule,
    NgxUiLoaderModule,
    ToastrModule
  ],
  providers: [ToastrService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  corporateToken: string = '';

  constructor(
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((res: any) => {
      if (res && res.token) {
        this.corporateToken = res.token;

        localStorage.setItem(
          environment.storageKey,
          this.corporateToken || ''
        );
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        document.body.scrollTop = 0;

        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });
  }
}